/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface IAccountOrderTemplatesTileDescription {
    description: string;
}

export const AccountOrderTemplatesTileDescription: React.FC<IAccountOrderTemplatesTileDescription> = ({ description }) => (
    <p className='ms-account-order-templates-tile__description'>{description}</p>
);
